import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { colors } from 'us-react-components/dist/constants/Styles';

type Props = {
  classNames?: string;
  icon: IconProp;
  text: string;
}

const IconText = (props: Props): JSX.Element => {
  const { classNames, text, icon } = props;

  return (
    <span className={`text-sm pb-0 xs:pb-2 sm:pb-3 flex flex-row items-center ${classNames ?? ''}`}>
      <div className='min-w-[20px]'>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <FontAwesomeIcon icon={icon} size='xl' style={{ '--fa-primary-color': colors.emerald.DEFAULT, '--fa-secondary-color': colors.emerald[300] } as any} />
      </div>
      <p className='text-sm pl-2'>{text}</p>
    </span>
  );
};

export { IconText };
